import { useEffect, useState } from 'react';
import { Identify, identify } from '@amplitude/analytics-browser';
import { initAmplitude, initPendo } from './utils';
import { RouterProvider } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import Router from 'pages/Router';
import { CookieBot } from 'components/CookieBot';
import './App.less';
import { isPendoEnvironmentSupported } from 'utils/Pendo';
import { HeadSectionGA } from 'components/HeadSection';
import { useElementInView } from 'hooks/useElementInView';
import { useTranslation } from 'react-i18next';
import { useCookieConsent } from 'hooks/useCookieConsent';

const setupHeightViewPortForMobile = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

function App() {
  const hasScrolledToBottom = useElementInView('footerSection');
  const [hasSpent60Seconds, setHasSpent60Seconds] = useState(false);
  const [showAmplitudeSurvey, setShowAmplitudeSurvey] = useState(false);
  const { i18n } = useTranslation();
  const { method } = useCookieConsent();

  useEffect(() => {
    const timer = setTimeout(() => {
      setHasSpent60Seconds(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (hasScrolledToBottom && hasSpent60Seconds) {
      setShowAmplitudeSurvey(true);
    }
  }, [hasScrolledToBottom, hasSpent60Seconds]);

  useEffect(() => {
    const currentLocale = i18n.language || 'en';
    if (method === 'explicit') {
      initAmplitude(showAmplitudeSurvey, currentLocale);

      if (process.env.REACT_APP_ENV && isPendoEnvironmentSupported(process.env.REACT_APP_ENV)) {
        initPendo('dev');
      }

      const identifyObj = new Identify();
      identifyObj.set('location', 'LAX');
      identify(identifyObj);

      setupHeightViewPortForMobile();
    }
  }, [showAmplitudeSurvey, i18n.language, method]);

  return (
    <div className="App" data-testid="app-main-component">
      <HeadSectionGA />
      <RouterProvider router={Router} />
      <CookieBot />
    </div>
  );
}

export default App;
